export default function MobileEmpty({ title = "Nada por aqui", message }) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <p className="text-lg font-medium text-laranjinha">{title}</p>
      {message ? <p className="mt-2 text-sm text-laranjinha/60">{message}</p> : null}
    </div>
  );
}
